import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import LocksetContent from "../Components/LocksetContent";

const Lockset = () => {
  const seoData = getSEOData("/schlage-lockset");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <LocksetContent />
    </>
  );
};

export default Lockset;